import Vue from "vue";
import Vuex from "vuex";
import user from './modules/user'
import permission from './modules/permission'
import section from './modules/section'
import getters from './getters'
Vue.use(Vuex);

export default new Vuex.Store({

  state: {},
  getters,
  mutations: {},
  actions: {},
  modules: {
    user,
    section,
    permission
  },
});
